import { DistanceUnit, formatDistance, DateUtils } from '@grandvisionhq/utils';

const formatDistanceQueryData = (data, options)=>{
    let { distanceUnit  } = options;
    const { locale  } = options;
    const { distance , timeByCar , timeByFoot  } = data;
    if (distance && distance < 1000) {
        if (distanceUnit === DistanceUnit.meter || distanceUnit === DistanceUnit.km) {
            distanceUnit = DistanceUnit.meter;
        }
    }
    // format the values when they are are not null or undefined
    return {
        distance: distance != undefined ? formatDistance(distance, distanceUnit, {
            separator: ' '
        }) : distance,
        timeByCar: timeByCar != undefined ? DateUtils.minutesToHM(timeByCar, locale) : timeByCar,
        timeByFoot: timeByFoot != undefined ? DateUtils.minutesToHM(timeByFoot, locale) : timeByFoot
    };
};

export { formatDistanceQueryData };
//# sourceMappingURL=adapters.js.map
